export interface Task {
  user: string;
  ticketId: string;
  createdby: string;
  ticketCreationDatetime: string;
  ticketClosureDatetime: string;
  taskStartDatetime: string;
  affectedCustomer: string[];
  affectedNetwork: string[];
  affectedSite: string[];
  affectedLink: string[];
  affectedAntenna: string;
  taskCloseDatetime: string;
  networkId: string | number | undefined;
  siteId: string | number | undefined;
  linkId: string | number | undefined;
  assetId: string | number | undefined;
  teamId: string | number | undefined;
  personId: string | number | undefined;
  communicationWithCustomer: string;
  userid: any;
  ticketCreation: string;
  ticketClosure: string;
  summary: string;
  taskStart: string;
  taskClose: string;
  email: string;
  taskResolutionTime: string;
  customerapproval: boolean;
  asset: string;
  errorType: string;
  closureCode: string;
  impact: string;
  urgency: string;
  priority: string;
  responsibleTeam: string;
  responsiblePerson: string;
  customerComplaint: boolean;
  customerInformed: boolean;
  status: string;
  journalUpdate: string;
  communication: string;
  description: string;
  reactionPoint: string;
  responseTimeToOpen: string;
  responseTimeToClose: string;
  acceptanceTime: string;
  acceptanceStatus: string;
  foruserid: number;
  filePath?: File[] | null;

  uploadPath: string;
  impacttaskCloseDatetime: string;
  imapcttaskStartDatetime: string;
  tasktype: string;
  relatedobject: string[];
  solution: string;
  phase: string;
}

export const initialTask: Task = {
  relatedobject: [],
  createdby: "",
  ticketId: "",
  userid: "",
  ticketCreation: "",
  ticketClosure: "",
  affectedAntenna: "",
  taskStart: "",
  taskClose: "",
  affectedCustomer: [],
  affectedNetwork: [],
  affectedSite: [],
  affectedLink: [],
  asset: "",
  summary: "",
  description: "",
  errorType: "",
  closureCode: "",
  impact: "",
  urgency: "",
  priority: "",
  responsibleTeam: "",
  responsiblePerson: "",
  customerComplaint: false,
  customerInformed: false,
  email: "",
  status: "",
  journalUpdate: "",
  communication: "",

  reactionPoint: "",
  responseTimeToOpen: "",
  responseTimeToClose: "",
  acceptanceTime: "",
  customerapproval: false,
  ticketCreationDatetime: "",
  ticketClosureDatetime: "",
  taskStartDatetime: "",
  taskCloseDatetime: "",
  networkId: undefined,
  siteId: undefined,
  linkId: undefined,
  assetId: undefined,
  teamId: undefined,
  personId: undefined,
  communicationWithCustomer: "",
  acceptanceStatus: "",
  foruserid: 0,
  filePath: [],
  uploadPath: "",
  impacttaskCloseDatetime: "",
  imapcttaskStartDatetime: "",
  tasktype: "",
  taskResolutionTime: "",
  solution: "",
  user: "",
  phase: "",
};
